























import { defineComponent, onMounted, Ref, ref } from '@vue/composition-api';
import ElInputNumber                            from 'element-ui/lib/input-number';

export default defineComponent({
  name: 'cInputNumber',
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ElInputNumber,
  },
  setup(props, { emit }) {
    const input: Ref<Element | null> = ref(null);
    onMounted((): void => {
      emit('update:input-ref', input.value);
    });
    return {
      input,
    };
  },
});
